import _get from "lodash/get"
import _forEach from "lodash/forEach"
import * as ActionTypes from "../action-types"

const MYCALLS_INITIAL_STATE = {
  loading: false,
  error: false,
  errorTest: false,
  callsOpen: [],
  callsInterrupted: [],
  callsClosed: [],
  inventoryData: null,
  device: null,
  protocol: null,
  idInteraction: null,
  dataPing: null,
  finishSuccess: false,
  loadingTicket: false,
  protocolNumberTicket: null,
  sendMail: {},
  closeOrderResult: false,
  lastOrders: [],
  isUploading: false,
  upload: {},
  workOrderSOM: [],
  workOrderControlDesk: [],
  loadingWorkOrder: false,
  loadingWorkOrderControlDesk: false
}

export function myCalls(state = MYCALLS_INITIAL_STATE, action) {
  let inventoryData, status, newError
  let protocolNumberTicket, device, open, interrupted, closed, newDataPing
  let serviceWork, serviceWorkId, serviceWork2, teste, finishSuccess
  let protocolNumber, orders, interactionNumber
  let listOrderSOM, listOrderControlDesk
  switch (action.type) {
    case ActionTypes.GET_INVENTARIO_DIGITAL:
      return { ...state }

    case ActionTypes.GET_INVENTARIO_DIGITAL_SUCCESS:
      inventoryData = _get(action, "payload.data", null)

      status = _get(action, "payload.status", null)
      newError = status === 204
      return { ...state, error: newError, errorTest: newError, inventoryData }

    case ActionTypes.GET_INVENTARIO_DIGITAL_FAIL:
      return { ...state, errorTest: true }

    case ActionTypes.OPEN_TICKET:
      return { ...state, loadingTicket: true }

    case ActionTypes.OPEN_TICKET_SUCCESS:
      protocolNumberTicket = _get(action, "payload.data.protocolNumber", null)
      return {
        ...state,
        protocolNumberTicket,
        loadingTicket: false,
        error: false
      }

    case ActionTypes.OPEN_TICKET_FAIL:
      return { ...state, loadingTicket: false, error: true }

    case ActionTypes.GET_INVENTARIO_DIGITAL_HOSTNAME:
      return { ...state, loading: false }

    case ActionTypes.GET_INVENTARIO_DIGITAL_HOSTNAME_SUCCESS:
      device = _get(action, "payload.data.deviceId", null)
      return { ...state, loading: false, device }

    case ActionTypes.GET_INVENTARIO_DIGITAL_HOSTNAME_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.GET_CALLS:
      return { ...state, loading: true }

    case ActionTypes.GET_CALLS_SUCCESS:
      open = []
      closed = []
      interrupted = []

      _forEach(action.payload.data, (call) => {
        const { status } = call

        if (status && status.toUpperCase() === "ABERTO") {
          open.push(call)
        }

        if (status && status.toUpperCase() === "FECHADO") {
          closed.push(call)
        }

        if (status && status.toUpperCase() === "INTERROMPIDO") {
          interrupted.push({ ...call, status: "ABERTO" })
        }
      })

      return {
        ...state,
        callsOpen: open,
        callsClosed: closed,
        callsInterrupted: interrupted,
        loading: false
      }

    case ActionTypes.GET_CALLS_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.SERVICE_TNCM2:
      return { ...state }

    case ActionTypes.SERVICE_TNCM2_SUCCESS:
      newDataPing = _get(action, "payload.data.pingId", null)
      return { ...state, dataPing: newDataPing }

    case ActionTypes.SERVICE_TNCM2_FAIL:
      return { ...state, error: true }

    case ActionTypes.SERVICE_TNCM3:
      return { ...state }

    case ActionTypes.SERVICE_TNCM3_SUCCESS:
      serviceWork = _get(action, "payload.data.workItemId", null)
      serviceWorkId = serviceWork || -1
      return { ...state, serviceWorkKey: serviceWorkId }

    case ActionTypes.SERVICE_TNCM3_FAIL:
      return { ...state, error: true }

    case ActionTypes.SERVICE_TNCM4:
      return { ...state }

    case ActionTypes.SERVICE_TNCM4_SUCCESS:
      serviceWork2 = _get(action, "payload.data", null)
      teste = serviceWork2.search("SUC-00001")
      finishSuccess = !(teste === -1)

      return { ...state, finishSuccess }

    case ActionTypes.SERVICE_TNCM4_FAIL:
      return { ...state, error: true }

    case ActionTypes.GET_PROTOCOL:
      return { ...state }

    case ActionTypes.GET_PROTOCOL_SUCCESS:
      protocolNumber = _get(action, "payload.data.protocol", null)
      return { ...state, protocol: protocolNumber }

    case ActionTypes.GET_PROTOCOL_FAIL:
      return { ...state, error: true }

    case ActionTypes.GET_INTERACTION:
      return { ...state }

    case ActionTypes.GET_INTERACTION_SUCCESS:
      interactionNumber = _get(action, "payload.data.interactionId", null)
      return { ...state, idInteraction: interactionNumber }

    case ActionTypes.GET_INTERACTION_FAIL:
      return { ...state }

    case ActionTypes.ADD_COMMENTS:
      return { ...state }

    case ActionTypes.ADD_COMMENTS_SUCCESS:
      return { ...state }

    case ActionTypes.ADD_COMMENTS_FAIL:
      return { ...state }

    case ActionTypes.SEND_MAIL_MY_CALLS:
      return { ...state, loading: true }

    case ActionTypes.SEND_MAIL_MY_CALLS_FAIL:
      return { ...state, sendMail: { error: true }, loading: false }

    case ActionTypes.SEND_MAIL_MY_CALLS_SUCCESS:
      return { ...state, sendMail: { success: true }, loading: false }

    case ActionTypes.CLOSE_ORDER:
      return { ...state, loading: true }

    case ActionTypes.CLOSE_ORDER_SUCCESS:
      return { ...state, closeOrderResult: true, loading: false }

    case ActionTypes.CLOSE_ORDER_FAIL:
      return { ...state, closeOrderResult: false, loading: false }

    case ActionTypes.LAST_ORDERS:
      return { ...state }

    case ActionTypes.LAST_ORDERS_SUCCESS:
      orders = _get(action, "payload.data", [])
      return { ...state, lastOrders: orders }

    case ActionTypes.LAST_ORDERS_FAIL:
      return { ...state }

    case ActionTypes.VERIFY_CIRCUIT:
      return { ...state }

    case ActionTypes.VERIFY_CIRCUIT_SUCCESS:
      return { ...state }

    case ActionTypes.UNBLOCKING_CIRCUIT:
      return { ...state }

    case ActionTypes.UNBLOCKING_CIRCUIT_SUCCESS:
      return { ...state }

    case ActionTypes.VERIFY_MASSIVE:
      return { ...state }

    case ActionTypes.VERIFY_MASSIVE_SUCCESS:
      return { ...state }

    case ActionTypes.VERIFY_CALLED:
      return { ...state }

    case ActionTypes.VERIFY_CALLED_SUCCESS:
      return { ...state }

    case ActionTypes.GET_DETAIL_PROTOCOL:
      return { ...state }

    case ActionTypes.GET_DETAIL_PROTOCOL_SUCCESS:
      return { ...state }

    case ActionTypes.ALGAR_INITIAL_TEST:
      return { ...state }

    case ActionTypes.ALGAR_INITIAL_TEST_SUCCESS:
      return { ...state }

    case ActionTypes.GET_ALGAR_VERIFY_TEST:
      return { ...state }

    case ActionTypes.GET_ALGAR_VERIFY_TEST_SUCCESS:
      return { ...state }

    case ActionTypes.PRE_SCHEDULE_WINDOWS:
      return { ...state }

    case ActionTypes.PRE_SCHEDULE_WINDOWS_SUCCESS:
      return { ...state }

    case ActionTypes.PRE_SCHEDULE:
      return { ...state }

    case ActionTypes.PRE_SCHEDULE_SUCCESS:
      return { ...state }

    case ActionTypes.CREATE_LEAD:
      return { ...state }

    case ActionTypes.CREATE_LEAD_SUCCESS:
      return { ...state }

    case ActionTypes.ATTACHMENT:
      return {
        ...state,
        isUploading: true,
        upload: {
          ...state.progress,
          [action.fileName]: {
            progress: 0,
            sucess: null
          }
        }
      }
    case ActionTypes.ATTACHMENT_SUCCESS:
      return {
        ...state,
        isUploading: false,
        upload: {
          ...state.upload,
          [action.meta.previousAction.fileName]: {
            ...state.upload[action.meta.previousAction.fileName],
            sucess: true
          }
        }
      }
    case ActionTypes.ATTACHMENT_FAIL:
      return {
        ...state,
        isUploading: false,
        upload: {
          ...state.upload,
          [action.meta.previousAction.fileName]: {
            ...state.upload[action.meta.previousAction.fileName],
            sucess: false
          }
        }
      }
    case ActionTypes.ATTACHMENT_PROGRESS:
      return {
        ...state,
        isUploading: false,
        upload: {
          ...state.upload,
          [action.fileName]: {
            ...state.upload[action.fileName],
            progress: action.progress
          }
        }
      }

    case ActionTypes.WORK_ORDER_SOM:
      return { ...state, loadingWorkOrder: true }
    case ActionTypes.WORK_ORDER_SOM_SUCCESS:
      listOrderSOM = _get(action, "payload.data", null)
      return {
        ...state,
        loadingWorkOrder: false,
        workOrderSOM: listOrderSOM
      }
    case ActionTypes.WORK_ORDER_SOM_FAIL:
      return {
        ...state,
        loadingWorkOrder: false
      }

    case ActionTypes.WORK_ORDER_CONTROL_DESK:
      return { ...state, loadingWorkOrderControlDesk: true }
    case ActionTypes.WORK_ORDER_CONTROL_DESK_SUCCESS:
      listOrderControlDesk = _get(action, "payload.data", null)
      return {
        ...state,
        loadingWorkOrderControlDesk: false,
        workOrderControlDesk: listOrderControlDesk
      }
    case ActionTypes.WORK_ORDER_CONTROL_DESK_FAIL:
      return {
        ...state,
        loadingWorkOrderControlDesk: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/myCalls/reducer.js